import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { Item, OwnerChargeInfo } from "../../resources";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

export interface ItemServiceFilters {
  pageSize?: number;
  page?: number;
  limit?: number;
  search?: string;
  friendlyName?: string;
}

@Injectable()
export class ItemService extends BaseDataService<Item> {
  constructor(http: HttpService) {
    super(http, "item");
  }

  createInstance(options: any): Item {
    return new Item(options);
  }

  filterBy(filters: ItemServiceFilters) {
    return this.all(filters);
  }

  exportList(searchParams: ItemServiceFilters) {
    return this.http.exportList(`${this.resourceUrl}/exportList`, { searchParams });
  }

  move(id: number, containerNumber: string): Observable<Item> {
    return this.runCommand("move", { id, containerNumber }).pipe(map((x) => x));
  }

  getNexNumber() {
    return this.http.request(`${this.resourceUrl}/nextnumber`);
  }

  chargeInfo(cai: string): Observable<OwnerChargeInfo> {
    return this.http.request(`${this.resourceUrl}/chargeInfo`, { searchParams: { cai } });
  }

  firlterByContainer(containerNo: string) {
    return this.filterBy({
      search: `container-number-"${containerNo}" sort-by-"Item Number" -Desc`,
    });
  }
}
